import * as React from "react";
import useKeyPress from "./use-key-press.js";
const useCursor = ({
  hasTopContent,
  onSubmit,
  onSuggestionClick,
  onSuggestionTopContentClick,
  ref,
  setIsSuggestionsOpen,
  suggestions
}) => {
  const startCursorValue = 0;
  const [cursor, setCursor] = React.useState(-1);
  const [hovered, setHovered] = React.useState(
    void 0
  );
  const downPress = useKeyPress("ArrowDown", ref);
  const upPress = useKeyPress("ArrowUp", ref);
  const enterPress = useKeyPress("Enter", ref);
  const spacePress = useKeyPress("Space", ref);
  React.useEffect(() => {
    if (!upPress) {
      return;
    }
    if (cursor < 0) {
      setCursor(suggestions.length);
      return;
    }
    setCursor((prevState) => {
      if (prevState > startCursorValue) {
        return prevState - 1;
      } else {
        setIsSuggestionsOpen(false);
        return -1;
      }
    });
  }, [upPress]);
  React.useEffect(() => {
    if (!downPress) {
      return;
    }
    if (cursor < 0) {
      setCursor(startCursorValue);
      return;
    }
    setCursor((prevState) => {
      const numberOfSuggestions = hasTopContent ? suggestions.length : suggestions.length - 1;
      if (prevState < numberOfSuggestions) {
        return prevState + 1;
      } else {
        setIsSuggestionsOpen(false);
        return -1;
      }
    });
  }, [downPress]);
  React.useEffect(() => {
    if (enterPress && cursor === -1 && typeof onSubmit === "function") {
      onSubmit();
      return;
    }
    if (enterPress && cursor === startCursorValue && typeof onSuggestionTopContentClick === "function") {
      onSuggestionTopContentClick();
      return;
    }
    const item = hasTopContent ? suggestions[cursor - 1] : suggestions[cursor];
    if (enterPress && suggestions.length && item) {
      onSuggestionClick(item.id);
    }
  }, [enterPress]);
  React.useEffect(() => {
    if (spacePress && cursor === startCursorValue && typeof onSuggestionTopContentClick === "function") {
      onSuggestionTopContentClick();
      return;
    }
    const item = hasTopContent ? suggestions[cursor - 1] : suggestions[cursor];
    if (spacePress && suggestions.length && item) {
      onSuggestionClick(item.id);
    }
  }, [spacePress]);
  React.useEffect(() => {
    if (hovered === "content") {
      setCursor(0);
      return;
    }
    if (hovered === void 0) {
      setCursor(-1);
    }
    if (suggestions.length && hovered) {
      const index = hasTopContent ? 1 : 0;
      setCursor(suggestions.indexOf(hovered) + index);
    }
  }, [hovered]);
  React.useEffect(() => {
    setCursor(-1);
  }, [suggestions]);
  return React.useMemo(() => ({ cursor, setCursor, setHovered }), [cursor, setCursor, setHovered]);
};
export {
  useCursor as default
};
//# sourceMappingURL=use-cursor.js.map
